export default __webpack_public_path__ + "static/icon-28-5-fe0b0cb90a38591b7ec1e0c4a9460b87.png";